import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    successUndo: (memberName: string, resourceName: string) => string | React.ReactNode;
    errorUndo: (resourceName: string, errorMessage?: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Success toast message when member is restored to resource */
            successUndo: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (memberName: string, resourceName: string) => __intl__.intl().formatMessage({ id: "useRestoreMembership.successUndo?c=opvkglyqhv62", defaultMessage: "{memberName} was re-added to {resourceName}" }, { memberName: memberName, resourceName: resourceName }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error toast message when restore fails */
            errorUndo: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (resourceName: string, errorMessage?: string) => __intl__.intl().formatMessage({ id: "useRestoreMembership.errorUndo?c=ka77znt3t38a", defaultMessage: "Unable to re-add to {resourceName}{errorMessage, select, true {: {errorMessage}} other {}}" }, { resourceName: resourceName, errorMessage: errorMessage }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
